import React, { useContext, useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import "./Cart.css";
import { useNavigate } from "react-router-dom";
import { updateCart, getCart } from "../../util/ApiService";
import { LanguageContext } from "../../context/LanguageContext";

const Cart = () => {
  const navigate = useNavigate();
  const [cartData, setCartData] = useState([]);
  const [couponCode, setCouponCode] = useState("");
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("users")));
  const { currentLang: selectedLanguage } = useContext(LanguageContext);

  const uuid = sessionStorage.getItem("uuid");

  useEffect(() => {
    fetchCart();
  }, []);

  const fetchCart = () => {
    getCart(selectedLanguage, user?.email)
      .then((response) => {
        if (response.data) {
          setCartData(response.data);
        }
      })
      .catch((err) => {
        console.log(1, err);
      });
  };

  const handleCheckout = () => {
    navigate("checkout");
  };

  const handleCartUpdate = (item, qty, isDeleted) => {
    const params = {
      sku: item.sku,
    };
    if (!isDeleted) {
      params.action = "U";
      params.qty = qty;
      params.id = item.cartId;
    } else {
      params.action = "D";
      params.userId = user?.email || uuid;
    }
    updateCart(params)
      .then((response) => {
        fetchCart();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const updateQuantity = (cartId, newQuantity, item) => {
    if (newQuantity < 1) return;

    setCartData((prevData) => ({
      ...prevData,
      productCart: prevData.productCart.map((item) =>
        item.cartId === cartId
          ? {
              ...item,
              qty: newQuantity,
              subTotal: Number((newQuantity * item.sellingPrice).toFixed(2)),
            }
          : item
      ),
    }));
    handleCartUpdate(item, newQuantity, false);
  };

  const handleQuantityChange = (cartId, value) => {
    const newQuantity = parseInt(value);
    if (!isNaN(newQuantity) && newQuantity >= 1) {
      updateQuantity(cartId, newQuantity);
    }
  };

  const deleteItem = (item, cartId) => {
    handleCartUpdate(item, null, true);
    setCartData((prevData) => ({
      ...prevData,
      productCart: prevData.productCart.filter(
        (item) => item.cartId !== cartId
      ),
    }));
  };

  const calculateTotal = () => {
    return (
      cartData?.productCart?.reduce(
        (sum, item) => sum + (item.subTotal || 0),
        0
      ) || 0
    );
  };

  const applyCoupon = () => {
    if (!couponCode) return;
    // applyCouponApi(couponCode)
    //   .then((response) => {
    //   })
    //   .catch((err) => {
    //     console.log("Coupon Error:", err);
    //   });
  };

  return (
    <div className="cart-container">
      <div className="cart-header">
        <a href="/" className="home-link">
          Home
        </a>
        <span className="separator">/</span>
        <span className="current-page">Cart</span>
      </div>

      <div className="cart-content">
        {cartData.productCart && cartData.productCart.length === 0 && (
          <div className="empty-cart-container">
            <div className="empty-cart-message">
              <h2>No products available</h2>
              <p>
                Your cart is currently empty. Browse through our products and
                add some to your cart.
              </p>
            </div>
            <div className="empty-cart-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="100"
                height="100"
                fill="none"
                stroke="#ccc"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M6 6h15l-1.5 9h-12L6 6z"></path>
                <circle cx="9" cy="19" r="2"></circle>
                <circle cx="17" cy="19" r="2"></circle>
              </svg>
            </div>
            <button
              className="continue-shopping-btn"
              // onClick={handleContinueShopping}
            >
              Continue Shopping
            </button>
          </div>
        )}

        {cartData.productCart && cartData.productCart.length > 0 && (
          <>
            <div className="cart-items-section">
              <div className="cart-table-header">
                <div className="header-product">Product</div>
                <div className="header-price">Price</div>
                <div className="header-size">Size</div>
                <div className="header-color">Color</div>
                <div className="header-quantity">Quantity</div>
                <div className="header-subtotal">Subtotal</div>
                <div className="header-action">Action</div>
              </div>

              {cartData.productCart.map((item) => (
                <div key={item.cartId} className="cart-item-cart">
                  <div className="item-product">
                    <img src={item.imageUrl} alt={item.name} />
                    <div className="product-details">
                      <span className="product-name">{item.name}</span>
                      <span className="product-brand">Brand: {item.brand}</span>
                    </div>
                  </div>
                  <div className="item-price">
                    <div className="price-details">
                      <span className="selling-price">
                        ${item.sellingPrice}
                      </span>
                      <span className="original-price">
                        ${item.originalPrice}
                      </span>
                      <span className="discount">
                        -{item.discountPercentage}%
                      </span>
                    </div>
                  </div>
                  <div className="item-size">{item.size}</div>
                  <div className="item-color">
                    <div
                      className="color-swatch"
                      style={{ backgroundColor: item.color }}
                    ></div>
                  </div>
                  <div className="item-quantity">
                    <div className="quantity-control">
                      <button
                        className="qty-btn"
                        onClick={() =>
                          updateQuantity(item.cartId, item.qty - 1, item)
                        }
                      >
                        -
                      </button>
                      <input
                        type="number"
                        value={item.qty}
                        onChange={(e) =>
                          handleQuantityChange(item.cartId, e.target.value)
                        }
                        min="1"
                      />
                      <button
                        className="qty-btn"
                        onClick={() =>
                          updateQuantity(item.cartId, item.qty + 1, item)
                        }
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <div className="item-subtotal">
                    ${item.subTotal.toFixed(2)}
                  </div>
                  <div className="item-action">
                    <button
                      className="delete-button"
                      onClick={() => deleteItem(item, item.cartId)}
                    >
                      <Trash2 size={20} />
                    </button>
                  </div>
                </div>
              ))}

              <div className="cart-actions">
                <button className="return-shop" onClick={() => navigate("/")}>
                  Return to Shop
                </button>
                {cartData.productCart && (
                  <button
                    className="update-cart"
                    onClick={() => navigate("/cart/checkout")}
                  >
                    Checkout
                  </button>
                )}
              </div>

              {/* {cartData.productCart && (
                <div className="coupon-section">
                  <input
                    type="text"
                    placeholder="Coupon Code"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value)}
                  />
                  <button className="apply-coupon" onClick={applyCoupon}>
                    Apply Coupon
                  </button>
                </div>
              )} */}
            </div>

            {cartData.productCart && (
              <div className="cart-total">
                <h2>Cart Total</h2>
                <div className="total-row">
                  <span>Subtotal:</span>
                  <span>${calculateTotal().toFixed(2)}</span>
                </div>
                <div className="total-row">
                  <span>Shipping:</span>
                  <span>Free</span>
                </div>
                <div className="total-row total">
                  <span>Total:</span>
                  <span>${calculateTotal().toFixed(2)}</span>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default Cart;
